<app-breadcrumb [title]="'Grievance View'"></app-breadcrumb>
<section class="container">
    <div class="card border-0 bg-white rounded-3 shadow mb-5">
        <div class="card-body">
            <div *ngIf="iRetursubmission" class="table-responsive pe-4 px-4">
                <table class="table align-middle table-bordered" style="width: 100%">
                    <colgroup>
                        <col style="width: 30%">
                        <col style="width: 70%">
                    </colgroup>
                    <thead class="edu-grid rounded">
                        <tr class="bg-primary text-white rounded p-2 tablegutterx-none gutterx-none">
                            <th colspan="2">Grievance Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Ref No</b></td>
                            <td>
                                {{iRetursubmission?.refNo}}
                            </td>
                        </tr>
                        <tr>
                            <td><b>Grievance Type</b></td>
                            <td>{{iRetursubmission?.grievanceTypes?.name}}</td>
                        </tr>
                        <tr>
                            <td><b>Date</b></td>
                            <td>{{iRetursubmission?.createdAt | date}}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-bordered align-middle mt-4" style="width: 100%">
                    <colgroup>
                        <col style="width: 30%">
                        <col style="width: 70%">
                    </colgroup>
                    <thead class="edu-grid rounded">
                        <tr class="bg-primary text-white rounded p-2 tablegutterx-none gutterx-none">
                            <th colspan="2">Employer Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Employer Shala Id</b></td>
                            <td>{{iRetursubmission?.profile?.applicationUser?.shalaId}}</td>
                        </tr>

                        <!-- <tr>
                            <td><b>Organisation Name</b></td>
                            <td>{{iRetursubmission?.userMaster?.userOrganisation?.organisationName}}</td>
                        </tr>
                        <tr>
                            <td><b>Organisation Address</b></td>
                            <td>
                                {{iRetursubmission?.userMaster?.userCommunication?.address1 +', '+
                                (iRetursubmission?.userMaster?.userCommunication?.taluka?.name ?
                                iRetursubmission?.userMaster?.userCommunication?.taluka?.name : '' )+', '+
                                iRetursubmission?.userMaster?.userCommunication?.district?.name}}
                            </td>
                        </tr> -->
                        <tr>
                            <td><b>Email Id</b></td>
                            <td>{{iRetursubmission?.profile?.applicationUser?.email}}</td>
                        </tr>
                        <tr>
                            <td><b>Mobile Number</b></td>
                            <td>{{iRetursubmission?.profile?.applicationUser?.phoneNumber}}</td>
                        </tr>
                        <!-- <tr>
                            <td><b>Contact Person Name</b></td>
                            <td>
                                {{iRetursubmission?.userMaster?.firstName + ' ' + iRetursubmission?.userMaster?.lastName
                                + ' ' + iRetursubmission?.userMaster?.middleName}}
                            </td>
                        </tr>
                        <tr>
                            <td><b>Sector</b></td>
                            <td>{{iRetursubmission?.userMaster?.userOrganisation?.sectorMaster?.name}}</td>
                        </tr>
                        <tr>
                            <td><b>Organisation Type</b></td>
                            <td>{{iRetursubmission?.userMaster?.userOrganisation?.organisationType?.name}}</td>
                        </tr> -->
                    </tbody>
                </table>
                <div class="row p-2 pt-0 pb-0">
                    <div class="col-12">
                        <hr />
                    </div>
                </div>
                <div>
                    <div class="px-lg-0">
                        <table class="table table-bordered table-bordered rounded mt-2">
                            <colgroup>
                                <col style="width: 30%" />
                                <col style="width: 30%" />
                            </colgroup>
                            <thead class="edu-grid rounded">
                                <tr class="bg-primary text-white rounded p-2 tablegutterx-none gutterx-none">
                                    <th>Document Name</th>
                                    <th>Attachment</th>
                                </tr>
                            </thead>
                            <tbody class="table-grid edu-grid rounded">
                                <tr class="text-dark p-3"
                                    *ngIf="!(this.iRetursubmission && this.iRetursubmission?.document)">
                                    <td colspan="2">
                                        <span class="text-center fw-bold">Document not added.</span>
                                    </td>
                                </tr>
                                <tr class="text-dark p-3"
                                    *ngIf="(this.iRetursubmission && this.iRetursubmission?.document)">
                                    <td>{{ this.iRetursubmission?.document?.title }}</td>
                                    <td>
                                        <a *ngIf="this.iRetursubmission?.document?.mediaUrl"
                                            [href]="this.iRetursubmission?.document?.mediaUrl"
                                            class="btn btn-sm btn-link" target="_blank">View
                                            Document</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="col-md-12 bg-primary text-white p-2">
                            <label class="mb-0">
                                <b>
                                    Inquiry/ Comments
                                </b>
                            </label>
                        </div>
                        <div class="col-md-12 p-2">
                            <label>{{iRetursubmission?.comment}}</label>
                        </div>
                    </div>
                    <div class="col-md-6" *ngIf="iRetursubmission?.recallComment">
                        <div class="col-md-12 bg-primary text-white p-2">
                            <label class="mb-0">
                                <b>
                                    Recall Comments
                                </b>
                            </label>
                        </div>
                        <div class="col-md-12 p-2">
                            <label>{{iRetursubmission?.recallComment}}</label>
                        </div>
                    </div>
                    <div class="col-md-6" *ngIf="iRetursubmission?.closeComment">
                        <div class="col-md-12  bg-primary text-white p-2">
                            <label class="mb-0">
                                <b>
                                    Close Comments
                                </b>
                            </label>
                        </div>
                        <div class="col-md-12 p-2">
                            <label>{{iRetursubmission?.closeComment}}</label>
                        </div>
                    </div>
                </div>
                <!-- <div class="row" *ngIf="iRetursubmission?.closeComment">
                    <div class="col-md-12 bg-primary text-white p-2" *ngIf="iRetursubmission?.closeComment">
                        <label class="mb-0">
                            <b>
                                Close Comments
                            </b>
                        </label>
                    </div>
                    <div class="col-md-12 p-2">
                        <label>{{iRetursubmission?.closeComment}}</label>
                    </div>
                </div> -->
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group mb-3 d-flex justify-content-end">
                        <button (click)="onBackClick()" class="btn btn-outline-dark rounded-3 border-2 m-3 px-5"
                            type="reset">Back</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>